export default "__VITE_ASSET__C05i_OQa__"